/**
 * Avoid JSON.stringify on customItems: entries often include React icon/label nodes (circular refs).
 * TODO: React.memo + stable refs upstream
 */
function areCustomItemsShallowEqual(prev, next) {
  if (prev === next) return true;
  if (!prev && !next) return true;
  if (!prev || !next) return false;
  if (!Array.isArray(prev) || !Array.isArray(next) || prev.length !== next.length) return false;
  for (let i = 0; i < prev.length; i += 1) {
    const a = prev[i];
    const b = next[i];
    if (a === b) continue;
    if (a?.key !== b?.key || a?.type !== b?.type) return false;
    if (a?.disabled !== b?.disabled || a?.danger !== b?.danger) return false;
    if (a?.onClick !== b?.onClick) return false;
  }
  return true;
}

export const arePropsEqual = (prevProps, nextProps) => {
  const userRolePrev = prevProps.userRole;
  const userRoleNext = nextProps.userRole;

  const userRoleEqual =
    userRolePrev?.isUserRole === userRoleNext?.isUserRole &&
    userRolePrev?.isSuperAdmin === userRoleNext?.isSuperAdmin &&
    userRolePrev?.canManage === userRoleNext?.canManage;

  return (
    prevProps.disabled === nextProps.disabled &&
    prevProps.mode === nextProps.mode &&
    prevProps.onStart === nextProps.onStart &&
    prevProps.onFavorite === nextProps.onFavorite &&
    prevProps.onTaskTraces === nextProps.onTaskTraces &&
    prevProps.isFavorite === nextProps.isFavorite &&
    prevProps.onConfig === nextProps.onConfig &&
    prevProps.onProcessConfig === nextProps.onProcessConfig &&
    prevProps.onDetail === nextProps.onDetail &&
    prevProps.onEdit === nextProps.onEdit &&
    prevProps.onRemove === nextProps.onRemove &&
    prevProps.all === nextProps.all &&
    prevProps.onBulkDownload === nextProps.onBulkDownload &&
    prevProps.onStartModeClick === nextProps.onStartModeClick &&
    prevProps.startMode === nextProps.startMode &&
    prevProps.isBulkRequestCreationEnabled === nextProps.isBulkRequestCreationEnabled &&
    prevProps.BulkUploadComponent === nextProps.BulkUploadComponent &&
    prevProps.viewMode === nextProps.viewMode &&
    prevProps.formatMessage === nextProps.formatMessage &&
    prevProps.configLabel === nextProps.configLabel &&
    areCustomItemsShallowEqual(prevProps.customItems, nextProps.customItems) &&
    userRoleEqual
  );
};
